<div class="row clearfix">
    <!-- Header graphic -->
    <div class="col-sm-12">
        <div class="gdpr-header-graphic"><span i18n>Access your data preferences</span></div>
    </div>
    <!-- / End Header graphic -->
    <div class="col-sm-12 gdpr-content-area">
        <h1 class="gdpr-h1" i18n>Please enter the verification code that you have received.</h1>
        <!-- Code validation section -->
        <form>
            <div class="row clearfix ">
                <div class="col-lg-10 col-md-10 col-sm-12 gdpr-code-box">
                    <div class="row clearfix">
                        <div class="col-lg-1 col-md-12 col-sm-12"></div>
                        <div class="col-lg-6 col-md-12 col-sm-12 form-group">
                            <input type="text" class="form-control" i18n-placeholder placeholder="Enter your code without spaces" name="name" [(ngModel)]="id" #name="ngModel" required i18n-placeholder>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12 form-group">
                            <button class="btn btn-block btn-primary takeme-btn" (click)="getContactByHashCode()" i18n>Continue</button>
                        </div>
                        <div class="col-lg-1 col-md-12 col-sm-12"></div>
                    </div>
                </div>
            </div>
        </form>
        <!-- / End code validation section -->

    </div>
    <div class="col-md-12">
        <h2 class="gdpr-h2 title gdpr-h2-margin" i18n>Need assistance?</h2>
    </div>
    <div class=" col-md-12 gdpr-para">
        <span i18n>Didn't receive a verification code? Questions?</span><br>
        <span i18n>Send an email to the <a href="mailto:data.preferences@spglobal.com">S&P Global Market Intelligence Support Team</a></span>
    </div>
</div>
<div id="overlay">
    <div class="row">
        <div class="col-sm-12">
            <div class="card card-alert">
                <div class="card-body">
                    <p class="text-danger"><span i18n>You have entered a verification code that our system does not recognize.</span></p>
                    <p i18n>The most common cause is a mistyped character and be advised the codes are case-sensitive. Please check the verification code and try again. Your code may have expired. If this is the case please contact S&P Global Market Intelligence Support <a href="mailto:data.preferences@spglobal.com"
                            class="text-danger">here</a>.</p>
                    <a href="index.html" class="alertbutton btn btn-danger btn-close" i18n>Close</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- / End Error Code Messages -->
<div class="my-container">
    <ngx-loading [show]="loading"></ngx-loading>
</div>